import React from "react";
import Padding from "@/components/shared/Padding";
import BackgroundTexture from "@/assets/img/backgrounds/halftone-header.webp";
import type { WindTypes } from "@/util/Tailwind";

const style = {
    outer: Wind.style({
        position: "absolute",
        inset: "inset-0",
    }),
    background: Wind.style({
        width: "w-full",
        height: "h-2/3",
        position: "absolute",
        backgroundBlendMode: "bg-blend-darken",
        backgroundPosition: "bg-bottom",
        backgroundSize: "bg-cover",
        opacity: "opacity-5",
        pointerEvents: "pointer-events-none"
    }),
    inner: Wind.style({
        position: "relative",
        display: "flex",
        flexDirection: "flex-col",
        alignItems: "items-center",
        justifyContent: "justify-center",
        height: "h-full",
        fontFamily: "font-default",
    }),
};

const PermissionsContainer = ({children, color}: React.PropsWithChildren<{
    color: WindTypes["backgroundColor"]
}>) => (
    <div
        className={Wind.mergeProps(
            style.outer.style,
            { backgroundColor: color }
        )}
    >
        <div
            className={style.background.class}
            style={{ backgroundImage: `url("${BackgroundTexture}")` }}
        />
        <Padding
            top={true}
            bottom={true}
        >
            <div className={style.inner.class}>
                {children}
            </div>
        </Padding>
    </div>
);

export default PermissionsContainer;
